import { filterUnique } from '../../../utils/array-utils';
import type { TileColor } from '../../boardMVC/TileColor';
import type { LevelData } from '../LevelData';
import { extractBoardStateColors } from '../../boardMVC/utils/extractBoardStateColors';
import { extractTrayStateColors } from '../../boardMVC/utils/extractTrayStateColor';

export function extractLevelColors(levelData: LevelData): TileColor[] {
  const boardColors = extractBoardStateColors(levelData.board);
  const trayColors = extractTrayStateColors(levelData.tray);
  return filterUnique([...boardColors, ...trayColors]).sort();
}
